import { HubConnectionBuilder } from "@microsoft/signalr";

const connection = new HubConnectionBuilder()
  .withUrl("/sofHub")
  .withAutomaticReconnect()
  .build();
connection.start();

export const pushNotification = {
  connection 
};
